export interface IImageLibraryItem {
  name: string;
  public_url: string;
  meta_data: {
    size: number;
    created_at: string;
    updated_at: string;
  };
}

export interface IUploadResponse {
  public_url: string;
}

export enum UploadFileTypeEnum {
  BulkEngagement = 'bulk_engagement',
  BulkInventoryItems = 'bulk_inventory_items',
  InventoryItem = 'product_image',
  OrgLogo = 'org_logo',
  OrgLogoTemp = 'org_logo_temp',
  EmailImage = 'email_image',
  InventoryCSV = 'inventory_csv',
  TemplateMedia = 'template_media',
}

export enum BackgroundTypesEnum {
  Color = 'Color',
  Image = 'Image',
}

export enum ImageSizeEnum {
  Fill = 'Fill',
  Fit = 'Fit',
}

export enum CSSObjectFitEnum {
  Cover = 'cover',
  Contain = 'contain',
  Fill = 'fill',
  None = 'none',
  ScaleDown = 'scale-down',
}

export enum CSSBackgroundPositionEnum {
  Top = 'top',
  Bottom = 'bottom',
  Left = 'left',
  Right = 'right',
  Center = 'center',
}
